export const TRY_OUT_SLUGS = ['boltz-3d-affinity', '3d-align', '3d-dock'] as const;
export type TryOutSlug = (typeof TRY_OUT_SLUGS)[number];

export function normalizeSlug(s: string | undefined): string {
  return (s || '').toLowerCase();
}

export function isTryOutSlug(slug: string | undefined): slug is TryOutSlug {
  if (!slug) return false;
  return (TRY_OUT_SLUGS as readonly string[]).includes(normalizeSlug(slug));
}

export type TryOutKind = 'boltz-3d-affinity' | 'batch';

export function tryOutKind(slug: string): TryOutKind {
  return normalizeSlug(slug) === 'boltz-3d-affinity' ? 'boltz-3d-affinity' : 'batch';
}

export function tryOutPageTitle(slug: string): string {
  const n = normalizeSlug(slug);
  if (n === 'boltz-3d-affinity') return 'Boltz 3D Affinity — Try out';
  if (n === '3d-align') return '3D Align — Try out';
  if (n === '3d-dock') return '3D Dock — Try out';
  return 'Try out';
}

const INSTRUCTIONS: Record<string, string> = {
  'boltz-3d-affinity': `Submit a JSON body for POST /requests (standard submission, up to the size limit in the API docs).

Authentication: your API key is sent automatically as x-api-key.

After submit, the tool polls GET /requests/{parent_request_id} until the job reaches a terminal state (COMPLETED or FAILED).

For very large payloads, use POST /requests/from-payload and direct upload (see full OpenAPI documentation).`,

  '3d-align': `Submit a JSON body for POST /requests with reference_ligand and ligands (see schema in the docs).

Authentication: your API key is sent automatically as x-api-key.

After submit, the tool polls GET /requests/{request_id} until pending and processing counts reach zero.`,

  '3d-dock': `Submit a JSON body for POST /requests with reference_ligand, protein, and ligands (see schema in the docs).

Authentication: your API key is sent automatically as x-api-key.

After submit, the tool polls GET /requests/{request_id} until pending and processing counts reach zero.`,
};

export function tryOutInstructions(slug: string): string {
  const n = normalizeSlug(slug);
  return INSTRUCTIONS[n] ?? INSTRUCTIONS['boltz-3d-affinity'];
}
